import React, { Component } from "react";
import "./rule.scss";
import title_tu from "../assets/title_tu.png";
import shareIcon from "../assets/share.png";
import QQ from "../assets/QQ.png";
import QQkongjian from "../assets/QQkongjian.png";
import weixin from "../assets/weixin.png";
import pengyouquan from "../assets/pengyouquan.png";
var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
export default class share extends React.Component {
   share = (type) =>{
	   let obj = {
	     type: type
	   };
	   let MYdata = JSON.stringify(obj);
	   if (isiOS) {
	     try {
	       window.webkit.messageHandlers.IOSNativePublishShare.postMessage(obj);
	     } catch (e) {
	       console.log(e);
	     }
	   } else {
	     try {
	       window.app.androidPublishShare(MYdata);
	     } catch (e) {
	       console.log(e);
	     }
	   }
   }
   
    render() {
		document.title = '发布成功';
        return ( 
			<div className = "share">
				<div className="cont">
					<div className="topdesc">
						<h2>发布成功 ”</h2>
						<p>将您的商品分享到微信群或者朋友圈，其它用户可以通过邮宝小程序与您快速交易！</p>
					</div>
					<img className="icon" src={title_tu} />
				</div>
				<div className="contRule">
					<img className="icon" src={shareIcon} />
					<div className = "shareRule" >
						1.金豆可以购买邮宝及邮宝微信小程序里（置顶、标题变色、匿名）等功能劵。< br/>
						2.金豆可以购买APP内的广告位推广自己的商品。< br/>
						3.金豆可以抵扣会员年费。< br/>
						4.<span>商品发布成功，帖子检测中，稍后正常显示.（违规信息将不显示）</span>< br/>
						5.发布完商品分享至微信朋友圈或者微信群可以免费查看当天行情。< br/>
						<p>点击下方分享，即可赚取金豆</p> 
					</div>  
				</div>
			    <div className="btnList">
					<dl onClick={() => this.share('wx')}>
						<dd> <img src={weixin} /> </dd>
						<dt>微信</dt>
					</dl>
					<dl onClick={() => this.share('pyq')}>
						<dd> <img src={pengyouquan} /> </dd>
						<dt>朋友圈</dt>
					</dl>
					{/* <dl onClick={() => this.share('qq')}>
						<dd> <img src={QQ} /> </dd>
						<dt>QQ</dt>
					</dl>
					<dl onClick={() => this.share('qqkj')}>
						<dd> <img src={QQkongjian} /> </dd>
						<dt>QQ空间</dt>
					</dl> */}
				</div>
			</div>
        );
    }
}